import {Box, Button} from '@mui/material'
import IconButton from '@mui/material/IconButton'
import {styled} from '@mui/material/styles'
import {FILTERS_DRAWER_WIDTH} from '../../components/FilterPanel/FilterPanelStyle'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableCell from '@mui/material/TableCell'
import TablePagination from '@mui/material/TablePagination'
import TableContainer from '@mui/material/TableContainer'
import {ArrowCircleDownRounded, ArrowForward, Search} from '@mui/icons-material'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import TextField from '@mui/material/TextField'

export const StyledBox = styled(Box)(() => ({
  marginTop: '80px',
  marginLeft: `-${FILTERS_DRAWER_WIDTH}px`
}))
export const StyledDiv = styled('div')(() => ({
  marginTop: '8px'
}))

export const StyledAnchor = styled('a')(({theme}) => ({
  textDecoration: 'none',
  color: theme.palette.hpAccentBlack,
  fontSize: theme.typography.h6.fontSize,
  fontWeight: theme.typography.fontWeightRegular
}))

export const StyledButton = styled(Button)(() => ({
  marginTop: '16px',
  height: '32px'
}))

export const StyledWarningAmberOutlinedIcon = styled(WarningAmberOutlinedIcon, {
  shouldForwardProp: (prop) => prop !== 'isCompleted' && prop !== 'leftPanelWarning'
})(({theme, isCompleted, leftPanelWarning}) => ({
  color: theme.palette.hpAccentOrange,
  height: '14px',
  visibility: isCompleted ? 'hidden' : '',
  marginLeft: leftPanelWarning && '-12px'
}))

export const StyledPaper = styled(Paper)(() => ({
  marginTop: '24px',
  overflow: 'visible',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px'
}))

export const StyledTableCell = styled(TableCell)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  width: '100%',
  padding: '16px'
}))

export const StyledTableContainer = styled(TableContainer)(() => ({
  overflow: 'hidden'
}))

export const StyledProjectListTable = styled(Table)(() => ({
  '& .MuiTableCell-root': {
    padding: '10px 14px'
  }
}))

export const StyledBackButton = styled(IconButton)(({theme}) => ({
  marginLeft: '-12px',
  marginRight: '5px',
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}))

export const StyledBackIcon = styled(ArrowCircleDownRounded)(({theme}) => ({
  transform: 'rotate(90deg)',
  fontSize: theme.typography.h4.fontSize
}))

export const StyledArrowForwardIcon = styled(ArrowForward)(({theme}) => ({
  fontSize: theme.typography.titleMedium.fontSize
}))

export const StyledTabs = styled(Tabs)(({theme}) => ({
  backgroundColor: theme.palette.hpBaseLighter,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.hpBaseLight}`,
  minHeight: 40,
  marginTop: '24px',
  padding: '10px',
  '& .MuiTabs-indicator': {
    display: 'none'
  }
}))

export const StyledTab = styled(Tab)(({theme}) => ({
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.text.primary,
  borderRadius: 8,
  minHeight: '0px',
  padding: '10px 16px',
  '&.Mui-selected': {
    backgroundColor: theme.palette.hpPrimary,
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightSemibold
  }
}))

export const StyledTablePagination = styled(TablePagination)(({theme}) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  '& .MuiTablePagination-toolbar': {
    minHeight: 48,
    padding: '0 16px'
  },
  '& .MuiTablePagination-spacer': {
    display: 'none'
  },
  '& .MuiTablePagination-selectLabel': {
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.primary
  },
  '& .MuiTablePagination-select': {
    fontSize: theme.typography.body2.fontSize,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: '4px 24px 4px 8px'
  },
  '& .MuiTablePagination-displayedRows': {
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.primary,
    marginLeft: 'auto'
  },
  '& .MuiTablePagination-actions': {
    marginLeft: 16,
    '& .MuiIconButton-root': {
      color: theme.palette.text.secondary,
      padding: 3,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: '100%',
      '&:hover': {
        backgroundColor: theme.palette.action.hover
      },
      '&:not(:first-child)': {
        marginLeft: 5
      }
    },
    '& .Mui-disabled': {
      color: theme.palette.action.disabled
    }
  }
}))

export const StyledSearchField = styled(TextField)(() => ({
  width: 340
}))

export const StyledSearchIcon = styled(Search)(({theme}) => ({
  fontSize: theme.typography.h6.fontSize
}))
